export const PERSON_SEARCH_PAGE_SIZE = 20;
